import { KeyboardEvent, PropsWithChildren, ReactNode } from 'react';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, useDisclosure } from '@ds';

type UserInfoModalProps = {
  trigger: ReactNode;
};

export const UserModalLayout = ({ trigger, children }: PropsWithChildren<UserInfoModalProps>) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const onModalKeyDown = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === 'Enter' || e.key === 'Space') {
      onOpen();
    }
  };

  return (
    <>
      <div
        role="button"
        aria-label="Open user profile"
        className="w-full"
        tabIndex={-1}
        onKeyDown={onModalKeyDown}
        onClick={onOpen}
      >
        {trigger}
      </div>
      <Modal
        classNames={{
          wrapper: 'flex-wrap',
          base: 'p-8 bg-base-80 w-full max-w-[1030px]',
          body: 'p-0 gap-6',
          footer: 'p-0 pt-6 justify-end',
        }}
        backdrop="opaque"
        isOpen={isOpen}
        onClose={onClose}
        hideCloseButton
      >
        <ModalContent>
          {(handleClose) => (
            <>
              <ModalBody>{children}</ModalBody>
              <ModalFooter>
                <Button variant="outline" className="min-w-32" size="md" onClick={handleClose}>
                  Close
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};
